import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { HttpApiService } from '../../../_services/http-api.service';

@Component({
  selector: 'app-file-upload-dialog',
  templateUrl: './file-upload-dialog.component.html',
  styleUrls: ['./file-upload-dialog.component.scss']
})
export class FileUploadDialogComponent implements OnInit {

  @ViewChild('fileUpload') fileUpload: any;

  // 待上傳檔案
  choosedFiles: any[] = [];

  cols_file: any[];

  constructor(
    private messageService: MessageService,
    private HttpApi: HttpApiService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private confirmationService: ConfirmationService,
  ) {

    this.cols_file = [
      { field: 'name', header: '檔名' },
      // { field: 'extension', header: '格式' },
      { field: 'size', header: '檔案大小' },
      { field: 'Creater', subfield: 'name', header: '上傳者' },
      { field: 'created_at', header: '更新時間' },
    ];
  }

  ngOnInit(): void {
    this.getFile(1, 100000, this.config.data.id)
  }

  uploadedFiles: any[] = []; // 已上傳檔案
  // Creater: any = {}
  getFile(page: number, limit: number, id: string) {
    this.HttpApi.getFileRequest(page, limit, id).subscribe(Request => {
      console.log(Request)

      this.uploadedFiles = []

      for (let file of Request.body.files) {
        this.uploadedFiles.push(file);
      }
      console.log('已上傳檔案', this.uploadedFiles)

    })
  }

  uploadFile(event) {
    console.log(event)

    this.choosedFiles = []

    for (let file of event.files) {
      this.choosedFiles.push(file);
    }

    for (var i = 0; i < this.choosedFiles.length; i++) {
      this.transformFile(this.choosedFiles[i])
      console.log(this.choosedFiles[i])
      console.log('檔案名稱', this.choosedFiles[i].name)
      console.log('檔案大小', this.choosedFiles[i].size)
    }

    console.log(this.choosedFiles);
    console.log(this.choosedFiles[0])

    console.log(this.filedata)



  }

  postFileRequest(filedata: any) {

    console.log(filedata)
    this.HttpApi.postFileRequest(filedata).subscribe(Request => {
      console.log(Request)

      switch (Request.code) {
        case 200:
          // this.messageService.add({ severity: 'success', summary: '確認', detail: '儲存成功' });
          this.messageService.add({ severity: 'success', summary: '成功', detail: '檔案上傳' });
          // for (let file of this.filedata) {
          // this.uploadedFiles.push(this.filedata);
          // }

          this.fileUpload.clear()
          this.getFile(1, 1000, this.config.data.id)


          break;
        case 413:
          this.messageService.add({ severity: 'error', summary: '失敗', detail: '上傳失敗' });

          break;
        default:
          this.messageService.add({ severity: 'error', summary: '失敗', detail: '上傳失敗' });
          break;
      }
    })
  }


  //轉碼
  filedata: any = {}
  filebytes: any // 檔案大小
  fileBase64: string // 檔案 base64
  // fileBinary: string
  fileExtension: string // 檔案格式
  transformFile(file: any) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.fileBase64 = <string>reader.result
      //this.fileBinary = atob(this.fileBase64.substring(this.fileBase64.indexOf(',') + 1))
      console.log(this.fileBase64)
      // console.log(this.fileBinary)

      this.fileExtension = file.name.slice((file.name.lastIndexOf(".") - 1 >>> 0) + 2);
      let base64test = this.fileBase64.split(',').pop();
      let filename = file.name.split('.').shift()
      this.filebytes = file.size.toFixed(2)
      this.bytechange(this.filebytes)
      // let filename = getfile.name.slice((getfile.name.lastIndexOf(".") - 1 >>> 0) + 2);
      console.log(filename)
      console.log(this.fileExtension)

      this.filedata['order_uuid'] = this.config.data.id
      this.filedata['name'] = file.name
      this.filedata['extension'] = this.fileExtension
      this.filedata['base64'] = base64test
      // this.filedata['creater'] = this.userJson.account_id
      this.filedata['size'] = this.filebytes
      console.log(this.filedata)

      this.postFileRequest(this.filedata)

    }
  }

  downloadFile(download_url: string) {
    window.location.href = download_url
  }

  //轉換檔案格式大小
  bytechange(bytes: any): void {
    const sizes = [" Bytes", " KB", " MB", " GB", " TB"];
    const i = Math.floor(Math.log(bytes) / Math.log(1000));
    this.filebytes = (bytes / Math.pow(1000, i)).toFixed(2) + sizes[i]
    console.log(this.filebytes)
  }

  deleteFile(id: string) {

    this.confirmationService.confirm({
      message: '確認刪除?',
      header: '注意',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {

        this.HttpApi.deleteFileRequest(id).subscribe(Request => {
          console.log(Request)

          switch (Request.code) {
            case 200:
              this.messageService.add({ severity: 'success', summary: '成功', detail: '檔案刪除' });

              this.getFile(1, 1000, this.config.data.id)

              break;
            default:
              this.messageService.add({ severity: 'error', summary: '失敗', detail: '刪除失敗' });
              break;
          }
        })
      }

    });


  }

}
